/**
 * Rhenus RVK API
 * \"Rhenus RVK user and admin API Definitions\"
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { inject, injectable, named } from "inversify";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Headers } from "../Headers";
import { HttpResponse } from "../HttpResponse";
import { IAPIConfiguration } from "../IAPIConfiguration";
import { IHttpClient } from "../IHttpClient";

import { JSONaddUserToLocation } from "../model/jSONaddUserToLocation";
import { JSONaddUserToLocationBNP } from "../model/jSONaddUserToLocationBNP";
import { JSONaddUserToLocationreturn } from "../model/jSONaddUserToLocationreturn";
import { JSONContactLocation } from "../model/jSONContactLocation";
import { JSONCustomerName } from "../model/jSONCustomerName";
import { JSONFElogging } from "../model/jSONFElogging";
import { JSONlocationId } from "../model/jSONlocationId";
import { JSONLocationName } from "../model/jSONLocationName";
import { JSONRhenusEmployee } from "../model/jSONRhenusEmployee";
import { JSONupdateUserData } from "../model/jSONupdateUserData";
import { JSONuserId } from "../model/jSONuserId";
import { Response } from "../model/response";

import { COLLECTION_FORMATS } from "../variables";
import { RvkAdminServiceInterface } from "./rvkAdmin.serviceInterface";

@injectable()
export class RvkAdminService implements RvkAdminServiceInterface {
  private basePath: string = "http://kubernetes.slsprototyp.de/service/rvk/api";

  constructor(
    @inject(IHttpClient)
    @named("RvkAdminService")
    private httpClient: IHttpClient,
    @inject(IAPIConfiguration)
    @named("RvkAdminService")
    private APIConfiguration: IAPIConfiguration
  ) {
    if (this.APIConfiguration.basePath) {
      this.basePath = this.APIConfiguration.basePath;
    }
  }

  /**
   * Assign a new user to the location
   * @param jsonuserlocation JSONaddUserToLocationBNP
   */
  public addUserToLocation(
    jsonuserlocation: JSONaddUserToLocationBNP,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public addUserToLocation(
    jsonuserlocation: JSONaddUserToLocationBNP,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public addUserToLocation(
    jsonuserlocation: JSONaddUserToLocationBNP,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (jsonuserlocation == null) {
      throw new Error(
        "Required parameter jsonuserlocation was null or undefined when calling addUserToLocation."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";
    headers["Content-Type"] = "application/json";

    const response: Observable<HttpResponse<Response>> = this.httpClient.post(
      `${this.basePath}/location/addUserToLocation`,
      jsonuserlocation,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }

  /**
   * Get a list of all locations that are assigned to me.
   */
  public allLocations(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONLocationName[]>;
  public allLocations(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONLocationName[]>>;
  public allLocations(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<JSONLocationName[]>
    > = this.httpClient.get(`${this.basePath}/location/allLocations`, headers);
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONLocationName[]
        )
      );
    }
    return response;
  }

  /**
   * Get a list of all users that are assigned to my location
   */
  public allUsersByMyLocation(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONuserId[]>;
  public allUsersByMyLocation(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONuserId[]>>;
  public allUsersByMyLocation(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<JSONuserId[]>
    > = this.httpClient.get(
      `${this.basePath}/location/allUsersByMyLocation`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) => httpResponse.payload as JSONuserId[]
        )
      );
    }
    return response;
  }

  /**
   * Get the contact information from the location
   */
  public contactLocations(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONContactLocation>;
  public contactLocations(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONContactLocation>>;
  public contactLocations(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<JSONContactLocation>
    > = this.httpClient.get(
      `${this.basePath}/location/contactLocations`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONContactLocation
        )
      );
    }
    return response;
  }

  /**
   * Endpoint to log FE logs
   * @param log log
   */
  public felogging(
    log: JSONFElogging,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public felogging(
    log: JSONFElogging,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public felogging(
    log: JSONFElogging,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (log == null) {
      throw new Error(
        "Required parameter log was null or undefined when calling felogging."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";
    headers["Content-Type"] = "application/json";

    const response: Observable<HttpResponse<Response>> = this.httpClient.post(
      `${this.basePath}/location/felogging`,
      log,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }

  /**
   * Get a list of all Rhenus that are assigned to the given location
   * @param locationName Name of the Location
   */
  public getAllRhenusWorkerByLocation(
    locationName: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONRhenusEmployee[]>;
  public getAllRhenusWorkerByLocation(
    locationName: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONRhenusEmployee[]>>;
  public getAllRhenusWorkerByLocation(
    locationName: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (locationName == null) {
      throw new Error(
        "Required parameter locationName was null or undefined when calling getAllRhenusWorkerByLocation."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<JSONRhenusEmployee[]>
    > = this.httpClient.get(
      `${this.basePath}/location/allRhenusByLocation/${encodeURIComponent(
        String(locationName)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONRhenusEmployee[]
        )
      );
    }
    return response;
  }

  /**
   * Get all customer names by the locationname
   * @param locationName Name of the location
   */
  public getCustomerNamesBylocationName(
    locationName: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONCustomerName[]>;
  public getCustomerNamesBylocationName(
    locationName: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONCustomerName[]>>;
  public getCustomerNamesBylocationName(
    locationName: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (locationName == null) {
      throw new Error(
        "Required parameter locationName was null or undefined when calling getCustomerNamesBylocationName."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<JSONCustomerName[]>
    > = this.httpClient.get(
      `${
        this.basePath
      }/location/customerNamesBylocationName/${encodeURIComponent(
        String(locationName)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONCustomerName[]
        )
      );
    }
    return response;
  }

  /**
   * Get the LocationId by customerId
   * @param userId Id of the User
   */
  public getLocationIdByCustomerId(
    userId: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONlocationId>;
  public getLocationIdByCustomerId(
    userId: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONlocationId>>;
  public getLocationIdByCustomerId(
    userId: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (userId == null) {
      throw new Error(
        "Required parameter userId was null or undefined when calling getLocationIdByCustomerId."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<JSONlocationId>
    > = this.httpClient.get(
      `${this.basePath}/location/locationId/${encodeURIComponent(
        String(userId)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) => httpResponse.payload as JSONlocationId
        )
      );
    }
    return response;
  }

  /**
   * Get a list of all customers who assigned to my location
   */
  public locationAll(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONCustomerName[]>;
  public locationAll(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONCustomerName[]>>;
  public locationAll(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<JSONCustomerName[]>
    > = this.httpClient.get(`${this.basePath}/location/all`, headers);
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONCustomerName[]
        )
      );
    }
    return response;
  }

  /**
   * update the Rhenus internal user Object
   * @param userData JSONupdateUserData
   */
  public updateUserData(
    userData: JSONupdateUserData,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public updateUserData(
    userData: JSONupdateUserData,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public updateUserData(
    userData: JSONupdateUserData,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (userData == null) {
      throw new Error(
        "Required parameter userData was null or undefined when calling updateUserData."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";
    headers["Content-Type"] = "application/json";

    const response: Observable<HttpResponse<Response>> = this.httpClient.put(
      `${this.basePath}/location/updateUserData`,
      userData,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }

  /**
   * Create a new User and assign him to the given Location
   * @param jsonuserlocation JSONaddUserToLocation
   */
  public userToLocation(
    jsonuserlocation: JSONaddUserToLocation,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONaddUserToLocationreturn>;
  public userToLocation(
    jsonuserlocation: JSONaddUserToLocation,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONaddUserToLocationreturn>>;
  public userToLocation(
    jsonuserlocation: JSONaddUserToLocation,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (jsonuserlocation == null) {
      throw new Error(
        "Required parameter jsonuserlocation was null or undefined when calling userToLocation."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";
    headers["Content-Type"] = "application/json";

    const response: Observable<
      HttpResponse<JSONaddUserToLocationreturn>
    > = this.httpClient.put(
      `${this.basePath}/location/createUserToLocation`,
      jsonuserlocation,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONaddUserToLocationreturn
        )
      );
    }
    return response;
  }
}
